export const parseEmailAddress = (emailString: string): { fullName: string; firstName: string; email: string } => {
  // Check if the string contains angle brackets (format: "Name" <email@domain.com>)
  const angleBracketMatch = emailString.match(/^"([^"]+)"\s*<(.+)>$/);

  if (angleBracketMatch) {
    // Format: "FirstName LastName" <email@domain.com>
    const fullName = angleBracketMatch[1];
    const email = angleBracketMatch[2];
    const firstName = fullName.split(" ")[0];

    return {
      fullName,
      firstName: capitalize(firstName),
      email,
    };
  }

  // Check if the string contains angle brackets without quotes (format: FirstName LastName <email@domain.com>)
  const noQuotesMatch = emailString.match(/^([^<]+)\s*<(.+)>$/);

  if (noQuotesMatch) {
    // Format: FirstName LastName <email@domain.com>
    const fullName = noQuotesMatch[1].trim();
    const email = noQuotesMatch[2];
    const firstName = fullName.split(" ")[0];

    return {
      fullName,
      firstName: capitalize(firstName),
      email,
    };
  }

  // Format: email@domain.com
  const email = emailString.trim();
  const address = email.split("@")[0];

  return {
    fullName: address,
    firstName: capitalize(address),
    email,
  };
};

const capitalize = (str: string): string => {
  if (!str || str.length === 0) {
    return str;
  }

  return str.charAt(0).toUpperCase() + str.slice(1);
};
